import { render, staticRenderFns } from "./Nodata.vue?vue&type=template&id=340b024c&"
import script from "./Nodata.vue?vue&type=script&lang=js&"
export * from "./Nodata.vue?vue&type=script&lang=js&"
import style0 from "./Nodata.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports